import { generateActionCreator as generate, reduxTypes as types } from 'ggtmo-utils';

export const RESIDENTS_GET_RESIDENT = generate('RESIDENTS_GET_RESIDENT', { type: types.ASYNC });
export const RESIDENTS_GET_ACCOUNT_REQUEST = generate('RESIDENTS_GET_ACCOUNT_REQUEST', { type: types.ASYNC });
export const RESIDENTS_UPDATE_ACCOUNT_REQUEST = generate('RESIDENTS_UPDATE_ACCOUNT_REQUEST', { type: types.ASYNC });
export const RESIDENTS_SELECT_RESIDENT = generate('RESIDENTS_SELECT_RESIDENT', { type: types.SYNC });
